import React from "react";
import { sizes } from "domains/theme/components/text";

import { Spinner, Text, VStack } from "@chakra-ui/react";
import { Html } from "@react-three/drei";

/**
 * Generic overlay loader used across the 3D viewer (Suspense fallback, wireframe processing, etc.)
 *
 * @note we are force to use the sizes export and the var(--chakra-colors-*) because the shorthands
 *       such as `bg="blackAlpha.900"` are not working
 */
export function OverlayLoader({
  message,
  subMessage,
}: {
  message: string;
  subMessage?: string;
}) {
  return (
    <Html
      center
      style={{
        zIndex: 1_000,
        pointerEvents: "none",
      }}
    >
      <VStack
        align="center"
        minW="280px"
        px={20}
        py={20}
        bg="var(--chakra-colors-blackAlpha-900)"
        borderWidth={0.5}
        borderColor="var(--chakra-colors-whiteAlpha-200)"
        borderRadius="var(--chakra-radii-xl)"
        shadow={`0 8px 32px var(--chakra-colors-blackAlpha-600)`}
        backdropFilter="blur(8px)"
        spacing={10}
      >
        <Spinner w="25px" h="25px" color="var(--chakra-colors-white)" />
        <Text
          color="var(--chakra-colors-textPrimary)"
          fontSize={sizes["body.bold.lg"].fontSize}
          fontWeight={sizes["body.bold.lg"].fontWeight}
          textAlign="center"
        >
          {message}
        </Text>
        {subMessage && (
          <Text
            color="var(--chakra-colors-whiteAlpha-700)"
            fontSize={sizes["body.lg"].fontSize}
            fontWeight={sizes["body.lg"].fontWeight}
            textAlign="center"
          >
            {subMessage}
          </Text>
        )}
      </VStack>
    </Html>
  );
}

export function ThreeDModelLoader() {
  return <OverlayLoader message="Loading 3D Model..." />;
}

export function WireframeLoader() {
  return (
    <OverlayLoader
      message="Processing wireframe..."
      subMessage="This may take a moment for complex models"
    />
  );
}
